import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconExperienceSvg } from "./IconExperienceSvg.mjs";
const IconExperience = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconExperienceSvg, ...svgProps }) });
export {
  IconExperience
};
